import { memo } from "react";
import { Navigate, type RouteObject, useParams } from "react-router-dom";

// HSA moved to /payments/hsa; keep the subpath (payment-analytics,
// funnel-analytics/:teamId) so old deep links land on the same page.
const HsaRedirect = memo(function HsaRedirect() {
  const subpath = useParams()["*"] || "payment-analytics";
  return <Navigate replace to={`/payments/hsa/${subpath}`} />;
});

export const conversionRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Conversion" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      { path: "hsa", element: <HsaRedirect /> },
      { path: "hsa/*", element: <HsaRedirect /> },
      {
        path: "intent",
        handle: { breadcrumb: "Intent" },
        children: [
          {
            path: "trials",
            handle: { breadcrumb: "Self-serve trials" },
            async lazy() {
              const { IntentTrialsPage } = await import("./intent-trials-page");
              return { Component: IntentTrialsPage };
            },
          },
        ],
      },
      {
        path: "ppu-intent",
        handle: { breadcrumb: "PPU intent" },
        children: [
          {
            path: "self-serve",
            handle: { breadcrumb: "Self-serve" },
            async lazy() {
              const { PpuIntentSelfServePage } =
                await import("./ppu-intent-self-serve-page");
              return { Component: PpuIntentSelfServePage };
            },
          },
        ],
      },
    ],
  },
];
